/*
 * 0.89 (K1): Board-Kontext „Worum es geht“ – eigener kleiner Abruf je Board. Live: `context.changed` lädt neu
 * (ohne Inhalte im Ereignis; jede Person liest mit ihren eigenen Rechten).
 */
import { useQuery } from '@tanstack/react-query';
import type { BoardContext } from '@kaba/shared';
import { api } from './api';

export const contextKey = (boardId: string) => ['context', boardId] as const;

export function useBoardContext(boardId: string, enabled = true) {
  return useQuery({ queryKey: contextKey(boardId), queryFn: () => api.get<BoardContext>(`/api/boards/${boardId}/context`), enabled, staleTime: 60_000 });
}

/** Wunsch, „Worum es geht“ zu öffnen (Boardkopf, Übersicht, Menü) – das Board hält das Panel */
export const openContext = (boardId: string, edit = false) => window.dispatchEvent(new CustomEvent('kaba-context-open', { detail: { boardId, edit } }));
